__turbopack_context__.v({
  "grid": "RecipePairings-module-scss-module__mseFzq__grid",
  "headline": "RecipePairings-module-scss-module__mseFzq__headline",
  "section": "RecipePairings-module-scss-module__mseFzq__section",
});
